// extracted by mini-css-extract-plugin
module.exports = {"tooltipStackingContext":"ShareButton_tooltipStackingContext__Qt3FL"};